// Libs
import React from 'react';
import ReactDOM from 'react-dom';

// Utils
import './static/js/utils/polyfills';
import 'focus-visible';

// Components
import App from './App';

// App
ReactDOM.render(<App />, document.getElementById('root'));
